// Pick the best non-empty value from an i18n map.
// Order: current locale -> English -> first non-empty. Empty/whitespace strings
// are treated as MISSING so a map like { en: '', es: 'Nombre' } falls back to ES
// instead of returning the empty English value.
function pick(map: Record<string, string>, lang: string): string {
  for (const key of [lang, 'en']) {
    const v = map[key]
    if (v && v.trim()) return v
  }
  for (const v of Object.values(map)) {
    if (v && v.trim()) return v
  }
  return ''
}

export function resolveI18n(
  val: string | Record<string, string> | null | undefined,
  locale?: string
): string {
  if (!val) return ''
  const lang = locale || localStorage.getItem('locale') || 'en'
  if (typeof val === 'string') {
    if (val.trimStart().startsWith('{')) {
      try {
        const parsed = JSON.parse(val) as Record<string, string>
        return pick(parsed, lang)
      } catch {
        return val
      }
    }
    return val
  }
  return pick(val, lang)
}
